export const CREATE_PAYMENT_TOKEN_SUCCESSFUL = 'CREATE_PAYMENT_TOKEN_SUCCESSFUL'
export const CREATE_PAYMENT_TOKEN_FAILED = 'CREATE_PAYMENT_TOKEN_FAILED'
export const PAYMENT_SUCCESSFUL = 'PAYMENT_SUCCESSFUL'
export const PAYMENT_FAILED = 'PAYMENT_FAILED'
export const PAYMENT_CANCELLED = 'PAYMENT_CANCELLED'
export const PAYMENT_CLEARED = 'PAYMENT_CLEARED'